/**
 * @generated SignedSource<<fafd0894209dad73ddf0e392129eeb5d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ChangePasswordQuery$variables = {
  token: string;
};
export type ChangePasswordQuery$data = {
  readonly login: {
    readonly id: string;
  } | null | undefined;
};
export type ChangePasswordQuery = {
  response: ChangePasswordQuery$data;
  variables: ChangePasswordQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "passwordResetToken",
        "variableName": "token"
      }
    ],
    "concreteType": "Login",
    "kind": "LinkedField",
    "name": "login",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePasswordQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ChangePasswordQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "2bd0b535385198fceffd8ab0042cf4ba",
    "id": null,
    "metadata": {},
    "name": "ChangePasswordQuery",
    "operationKind": "query",
    "text": "query ChangePasswordQuery(\n  $token: String!\n) {\n  login(passwordResetToken: $token) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "684c9114305b6838736f9ac1c57ad95d";

export default node;
